/**
 * @generated SignedSource<<91655d8421aa9aa536af98bd1646a3d6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LinkedWorkspaceProductItem_WorkspaceProduct$data = {
  readonly id: string;
  readonly imageUrl: string | null;
  readonly name: string | null;
  readonly partNumber: string | null;
  readonly " $fragmentType": "LinkedWorkspaceProductItem_WorkspaceProduct";
};
export type LinkedWorkspaceProductItem_WorkspaceProduct$key = {
  readonly " $data"?: LinkedWorkspaceProductItem_WorkspaceProduct$data;
  readonly " $fragmentSpreads": FragmentRefs<"LinkedWorkspaceProductItem_WorkspaceProduct">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LinkedWorkspaceProductItem_WorkspaceProduct",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "partNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "WorkspaceProduct",
  "abstractKey": null
};

(node as any).hash = "5919907abb1b56fa58c48898f2abab26";

export default node;
